import { forwardRef, useCallback } from 'react';
import { SettingsPanelPortal, type SettingsPanelPortalProps } from './settings-panel-portal';
import { useSettingsPanelStore } from './store';

type GlobalSettingsPanelEntryProps = Omit<SettingsPanelPortalProps, 'onClose'> & {
  onClose?: () => void;
};

export const GlobalSettingsPanelEntry = forwardRef<HTMLDivElement, GlobalSettingsPanelEntryProps>(
  ({ children, id, onClose, enableAnimations = true, ...rest }: GlobalSettingsPanelEntryProps, ref) => {
    const setOpenGlobalPanel = useSettingsPanelStore((s) => s.setOpenGlobalPanel);
    const isOpenGlobalPanel = useSettingsPanelStore((s) => s.openGlobalPanels?.[id]);

    const handleClose = useCallback(() => {
      setOpenGlobalPanel(id, false);
      onClose?.();
    }, [id, setOpenGlobalPanel, onClose]);

    if (!isOpenGlobalPanel) {
      return null;
    }

    return (
      <SettingsPanelPortal enableAnimations={enableAnimations} id={id} onClose={handleClose} {...rest} ref={ref}>
        {children}
      </SettingsPanelPortal>
    );
  }
);

GlobalSettingsPanelEntry.displayName = 'GlobalSettingsPanelEntry';
